import { ReactElement } from 'react'
import { useErrorHandler } from 'react-error-boundary'
import ErrorFallback from '../components/ErrorFallbackWithMessage'
import * as Sentry from '@sentry/react'

const useCustomErrorHandler = () => {
  const handleError = useErrorHandler()

  // This method is used for handling errors when state needs to be set
  const setStateErrorHandler = (toState: any) => {
    try {
    } catch (error) {
      Sentry.captureException(error)
      console.log(error)
      handleError(error)
    }
  }

  const errorFallBack = (message: string): ReactElement<any, any> => {
    return <ErrorFallback message={message} />
  }

  const logErrorToDatabase = (error: any, info: { componentStack: string }) => {
    // const obj = {
    //     error: error.toString(),
    //     info: info.componentStack
    // };
    Sentry.captureException(error)
    // console.log(error.toString(), info.componentStack);
  }

  return {
    setStateErrorHandler,
    logErrorToDatabase,
    errorFallBack,
  }
}

export default useCustomErrorHandler
